export function formatTime(milliseconds: number): string {
  if (!milliseconds || milliseconds < 0) return '00:00.000'

  const totalSeconds = Math.floor(milliseconds / 1000)
  const ms = Math.floor(milliseconds % 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}.${ms.toString().padStart(3, '0')}`
}

export function formatTimeDifference(milliseconds: number): string {
  if (!milliseconds || milliseconds < 0) return '+0.000'

  const totalSeconds = Math.floor(milliseconds / 1000)
  const ms = Math.floor(milliseconds % 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  if (minutes > 0) {
    return `+${minutes}:${seconds.toString().padStart(2, '0')}.${ms
      .toString()
      .padStart(3, '0')}`
  }

  return `+${seconds}.${ms.toString().padStart(3, '0')}`
}

export function getPositionOrdinal(position: number): string {
  if (position === 1) return '1st'
  if (position === 2) return '2nd'
  if (position === 3) return '3rd'
  return `${position}th`
}

export function getMedalEmoji(position: number): string {
  if (position === 1) return '🥇'
  if (position === 2) return '🥈'
  if (position === 3) return '🥉'
  return ''
}

export function getBoatColorStyle(color: string): React.CSSProperties {
  return {
    backgroundColor: color,
    boxShadow: `0 0 20px ${color}80, inset 0 0 10px ${color}40`,
  }
}

export function interpolateColor(
  color1: string,
  color2: string,
  factor: number
): string {
  const c1 = parseInt(color1.replace('#', ''), 16)
  const c2 = parseInt(color2.replace('#', ''), 16)

  const r1 = (c1 >> 16) & 255
  const g1 = (c1 >> 8) & 255
  const b1 = c1 & 255

  const r2 = (c2 >> 16) & 255
  const g2 = (c2 >> 8) & 255
  const b2 = c2 & 255

  const r = Math.round(r1 + (r2 - r1) * factor)
  const g = Math.round(g1 + (g2 - g1) * factor)
  const b = Math.round(b1 + (b2 - b1) * factor)

  return `rgb(${r}, ${g}, ${b})`
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max)
}

export function sortLeaderboard(participants: any[]): any[] {
  return [...participants].sort((a, b) => {
    if (a.total_laps !== b.total_laps) {
      return b.total_laps - a.total_laps
    }
    if (a.best_lap_time && b.best_lap_time) {
      return a.best_lap_time - b.best_lap_time
    }
    return 0
  })
}

export function calculateGap(
  currentLapTime: number | null,
  leaderLapTime: number | null
): number | null {
  if (!currentLapTime || !leaderLapTime) return null
  return currentLapTime - leaderLapTime
}
